import { makeRequestAuth } from "../utils/globals";

class ProfileService {
  /**
   * @param {type} addressDetails
   * @returns {promise}
   */
  addressDetails(payload) {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.query.fetch_address";
      const request_data = {
        query: query,
        tag: "storeAdmin",
      };

      makeRequestAuth(request_data, (response) => {
        //if(response && response.error) { reject(new Error(error.error_msg)) }

        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  adminDetails(payload) {
    return new Promise((resolve, reject) => {
      const query = "plum_tp_integrations.query.getUserDetails"; //"storesAdmin.query.fetchAdminDetails";
      const request_data = {
        query: query,
        tag: "plum_tp_integrations", //'storeAdmin',
        variables: {},
        // variables:{
        // 	add_data:{
        // 		application_type:'stores',
        // 		status:1
        // 	}
        // }
      };

      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  getClientId(payload) {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.query.getClientId";
      const request_data = {
        query: query,
        tag: "storeAdmin",
      };

      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  updatePlatformSetting(payload) {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.mutation.updatePlatformSetting";
      const request_data = {
        query: query,
        tag: "storeAdmin",
        variables: {
          add_data: payload,
        },
      };

      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  getPlatformSetting(payload) {
    return new Promise((resolve, reject) => {
      const query = "stores.mutation.fetchPlatformSetting";
      const request_data = {
        query: query,
        tag: "stores",
        variables: {
          add_data: payload,
        },
      };

      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  getTemplatesByAlbumName(payload) {
    return new Promise((resolve, reject) => {
      const albumReq = "storesAdmin.query.template_fetch_album";

      const request_data = {
        query: albumReq,
        tag: "storeAdmin",
        variables: {
          ...payload,
        },
      };

      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  getMenuforActiveIntegration(payload) {
    return new Promise((resolve, reject) => {
      const query = "survey_monkey.query.get_active_integration";
      const request_data = {
        query: query,
        tag: "survey_monkey",
        variables: {
          include_active: true,
          application_type: "stores",
        },
      };

      makeRequestAuth(request_data, (response) => {
        if (
          response &&
          response.data &&
          response.data.getActiveIntegration &&
          response.data.getActiveIntegration.success == 1
        ) {
          resolve(response.data.getActiveIntegration.result.active);
        } else {
          resolve(0);
        }
      });
    });
  }

  getActiveIntegrationCount(payload) {
    return new Promise((resolve, reject) => {
      const query = "survey_monkey.query.get_active_integration_count";
      const request_data = {
        query: query,
        tag: "survey_monkey",
        variables: {
          include_active: true,
          application_type: "stores",
        },
      };

      makeRequestAuth(request_data, (response) => {
        if (
          response &&
          response.data &&
          response.data.getActiveIntegrationCount &&
          response.data.getActiveIntegrationCount.success == 1
        ) {
          resolve(response.data.getActiveIntegrationCount.result);
        } else {
          resolve(0);
        }
      });
    });
  }

  getAllIntegration(payload) {
    return new Promise((resolve, reject) => {
      const query = "survey_monkey.query.get_all_integration";
      const request_data = {
        query: query,
        tag: "survey_monkey",
        variables: {
          type: "plum",
          integration_type: "custom",
        },
      };

      makeRequestAuth(request_data, (response) => {
        if (
          response &&
          response.data &&
          response.data.getAllIntegration &&
          response.data.getAllIntegration.success == 1
        ) {
          resolve(response.data.getAllIntegration.result);
        } else {
          resolve(0);
        }
      });
    });
  }

  getMenuforAwardAccess(payload) {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.mutation.award_company_detail";
      const request_data = {
        query: query,
        tag: "storeAdmin",
      };

      makeRequestAuth(request_data, (response) => {
        if (
          response &&
          response.data &&
          response.data.awardCompanyDetail &&
          response.data.awardCompanyDetail.success == 1
        ) {
          resolve(1);
        } else {
          resolve(0);
        }
      });
    });
  }

  plumProPoints(payload) {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.query.cash_reserve_balance";
      const request_data = {
        query: query,
        tag: "storeAdmin",
      };

      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  fetchCountryBasedonIP(payload) {
    return new Promise((resolve, reject) => {
      const query = "stores.query.plumApi";
      const add_data = {
        key: "vd",
        method: "files/ipDetails",
        url_type: "node_partner",
      };
      const request_data = {
        query: query,
        tag: "stores",
        variables: {
          add_data: add_data,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      },
      {},
      "/api/public/graph");
    });
  }

  userBalance(payload) {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.query.voucher_balance";
      const request_data = {
        query: query,
        tag: "storeAdmin",
      };

      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  }

  countryList = () => {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.query.country_query";
      const request_data = {
        query: query,
        tag: "stores",
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  stateList = (countryId) => {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.query.state_query";
      const request_data = {
        query: query,
        tag: "stores",
        variables: {
          country_id: countryId,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  cityList = (stateId) => {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.query.city_query";
      const request_data = {
        query: query,
        tag: "stores",
        variables: {
          state_id: stateId,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  /**
   * @Description : To check super superadmin
   * @returns{promise}
   */
  getMenu() {
    return new Promise((resolve, reject) => {
      const query = "stores.query.getMenu";
      const postData = {
        query: query,
        tag: "stores",
      };
      makeRequestAuth(postData, (response) => {
        if (
          response.data &&
          response.data.getMenu &&
          response.data.getMenu.success
        ) {
          resolve(response.data.getMenu);
        } else {
          resolve(0);
        }
      });
    });
  }

  getMultiAdminList(fetchParams) {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.query.getMultiAdminList";
      const postData = {
        query: query,
        tag: "storeAdmin",
        variables: fetchParams,
      };
      makeRequestAuth(postData, (response) => {
        if (
          response.data &&
          response.data.getMultiAdminList &&
          response.data.getMultiAdminList.data &&
          response.data.getMultiAdminList.status === true
        ) {
          resolve(response.data.getMultiAdminList.data);
        } else {
          reject(new Error("Something Went Wrong"));
        }
      });
    });
  }
  addAdmin(payload) {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.mutation.addAdmin";
      const postData = {
        query: query,
        tag: "storeAdmin",
        variables: {
          add_data: payload,
        },
      };
      makeRequestAuth(postData, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve(0);
        }
      });
    });
  }
  updateAdmin(payload) {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.mutation.updateAdmin";
      const postData = {
        query: query,
        tag: "storeAdmin",
        variables: {
          add_data: payload,
        },
      };
      makeRequestAuth(postData, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve(0);
        }
      });
    });
  }
  getAdminDetailById() {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.query.getMultiAdminById";
      const postData = {
        query: query,
        tag: "storeAdmin",
      };
      makeRequestAuth(postData, (response) => {
        if (
          response.data &&
          response.data.getMenu &&
          response.data.getMenu.success
        ) {
          resolve(response.data.getMenu);
        } else {
          resolve(0);
        }
      });
    });
  }

  /**
   * @Description : get module access list
   * @returns{promise}
   */
  getUserModuleAccess() {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.query.getUserModuleAccessList";
      const postData = {
        query: query,
        tag: "storeAdmin",
      };
      makeRequestAuth(postData, (response) => {
        if (
          response &&
          response.data &&
          response.data.getUserModuleAccess &&
          response.data.getUserModuleAccess.error == "false"
        ) {
          let moduleAcl = response.data.getUserModuleAccess.data
            ? response.data.getUserModuleAccess.data
            : [];
          resolve(moduleAcl);
        } else {
          resolve([]);
        }
      });
    });
  }

  sendReport(payload) {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.query.downloadBulkReport";
      const postData = {
        query: query,
        tag: "storeAdmin",
        variables: {
          add_data: payload,
        },
      };
      makeRequestAuth(postData, (response) => {
        if (response && response.data && response.data.downloadBulkReport) {
          resolve(response.data.downloadBulkReport);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  }

  downloadReport(payload) {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.query.downloadEmpulsReport";
      const postData = {
        query: query,
        tag: "storeAdmin",
        variables: {
          add_data: payload,
        },
      };
      makeRequestAuth(postData, (response) => {
        if (response && response.data && response.data.downloadEmpulsReport) {
          resolve(response.data.downloadEmpulsReport);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  }

  /*
   * @Description : get plum points report
   * @returns{promise}
   */
  plumPointReport = (addData, signal = false) => {
    return new Promise((resolve, reject) => {
      const PlumPointsReport = {
        query: "storesAdmin.query.getPlumPointsReport",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(
        PlumPointsReport,
        (response) => {
          if (response && response.data) {
            resolve(response);
          } else {
            resolve({ Message: "Something went wrong", success: 0 });
          }
        },
        "",
        "",
        signal
      );
    });
  };

  /*
   * @Description : get plum voucher report
   * @returns{promise}
   */
  plumVoucherReport = (addData) => {
    return new Promise((resolve, reject) => {
      const PlumVoucherReport = {
        query: "storesAdmin.query.getPlumVoucherReport",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(PlumVoucherReport, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  /*
   * @Description : get plum payments report
   * @returns{promise}
   */
  plumPaymentsReport = (addData, signal = false) => {
    return new Promise((resolve, reject) => {
      const PlumPaymentReport = {
        query: "storesAdmin.query.getPlumPaymentReport",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(
        PlumPaymentReport,
        (response) => {
          if (response) {
            resolve(response);
          } else {
            resolve({ Message: "Something went wrong", success: 0 });
          }
        },
        "",
        "",
        signal
      );
    });
  };

  /*
   * @Description : cancel voucher code
   * @input : voucher id
   * @returns{promise}
   */
  xoxoVoucherCodeCancel = (voucher_id) => {
    const base64regex =
      /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
    let id = !base64regex.test(voucher_id) ? voucher_id : atob(voucher_id);
    return new Promise((resolve, reject) => {
      const queryData = {
        query: "storesAdmin.mutation.xoxoVoucherCodeCancel",
        tag: "storeAdmin",
        variables: {
          voucher_id: id,
        },
      };
      makeRequestAuth(queryData, (response) => {
        if (
          response &&
          response.data &&
          response.data.xoxoVoucherCodeCancel &&
          response.data.xoxoVoucherCodeCancel.output
        ) {
          resolve(response.data.xoxoVoucherCodeCancel.output);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  /*
   * @Description : cancel xoxo point
   * @input : voucher id
   * @returns{promise}
   */
  xoxoPointCancel = (voucher_id) => {
    const base64regex =
      /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
    let id = !base64regex.test(voucher_id) ? voucher_id : atob(voucher_id);
    return new Promise((resolve, reject) => {
      const queryData = {
        query: "storesAdmin.mutation.xoxoPointCancel",
        tag: "storeAdmin",
        variables: {
          voucher_id: id,
        },
      };
      makeRequestAuth(queryData, (response) => {
        if (
          response &&
          response.data &&
          response.data.xoxoPointCancel &&
          response.data.xoxoPointCancel.output
        ) {
          resolve(response.data.xoxoPointCancel.output);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  /*
   * @Description : sends email for voucher id
   * @returns{promise}
   */
  plumResendVoucher = (addData) => {
    return new Promise((resolve, reject) => {
      const plumResendVoucher = {
        query: "storesAdmin.mutation.resendGiftCardCode",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(plumResendVoucher, (response) => {
        if (response && response.data && response.data.resendGiftCardCode) {
          resolve(response.data.resendGiftCardCode);
        } else {
          reject(new Error("Api Error"));
        }
      });
    });
  };

  /*
   * @Description : sends email for voucher id
   * @returns{promise}
   */
  plumReportGetCsv = (addData) => {
    return new Promise((resolve, reject) => {
      const plumReportGetCsv = {
        query: "storesAdmin.query.plumReportGetCsv",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(plumReportGetCsv, (response) => {
        if (response && response.data && response.data.plumReportGetCsv) {
          resolve(response.data.plumReportGetCsv);
        } else {
          reject(new Error("Api Error"));
        }
      });
    });
  };

  proformaInvoice = (addData) => {
    return new Promise((resolve, reject) => {
      const ProformaInvoice = {
        query: "storesAdmin.mutation.getProformaInvoice",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(ProformaInvoice, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  fetchVoucherCountryList = () => {
    let filterVoucherParams = { url: "/", filter_group_id: "41" };
    return new Promise((resolve, reject) => {
      const list = {
        query: "voucher.mutation.filter_list",
        tag: "voucher",
        variables: { filtersParams: JSON.stringify(filterVoucherParams) },
      };
      makeRequestAuth(list, (response) => {
        if (
          response &&
          response.data &&
          response.data.fetchVouchersFilters &&
          response.data.fetchVouchersFilters.filters
        ) {
          resolve(response.data.fetchVouchersFilters);
        } else {
          resolve({
            Message: "Something went wrong",
            success: 0,
          });
        }
      });
    });
  };
  fetchOneClickCampaignSites(params) {
    return new Promise((resolve, reject) => {
      const getsites = {
        query: "storesAdmin.query.getOneClickSiteList",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(
        getsites,
        function (response) {
          if (
            response &&
            response.data &&
            response.data.getOneClickSiteList &&
            response.data.getOneClickSiteList.success
          ) {
            resolve(response.data.getOneClickSiteList);
          } else if (
            response &&
            response.data &&
            response.data.getOneClickSiteList &&
            !response.data.getOneClickSiteList.success &&
            response.data.getOneClickSiteList.errors
          ) {
            resolve(response.data.getOneClickSiteList);
          } else {
            resolve({ Message: "Something went wrong", success: 0 });
          }
        }.bind(this)
      );
    });
  }
  fetchOneClickCampaignCountries() {
    return new Promise((resolve, reject) => {
      const getsites = {
        query: "storesAdmin.query.getOneClickSiteCountryList",
        tag: "storeAdmin",
        variables: {},
      };
      makeRequestAuth(
        getsites,
        function (response) {
          if (
            response &&
            response.data &&
            response.data.getOneClickSiteCountryList &&
            response.data.getOneClickSiteCountryList.success
          ) {
            resolve({
              data: response.data.getOneClickSiteCountryList.data,
              success: 1,
            });
          } else {
            resolve({ Message: "Something went wrong", success: 0 });
          }
        }.bind(this)
      );
    });
  }
  fetchOneClickCampaignDenominations(params) {
    return new Promise((resolve, reject) => {
      const getsites = {
        query: "storesAdmin.query.getOneClickSiteDenomination",
        tag: "storeAdmin",
        variables: {
          add_data: {
            ...params,
          },
        },
      };
      makeRequestAuth(
        getsites,
        function (response) {
          if (
            response &&
            response.data &&
            response.data.getOneClickSiteDenomination &&
            response.data.getOneClickSiteDenomination.success
          ) {
            resolve(response.data.getOneClickSiteDenomination);
          } else {
            resolve({ Message: "Something went wrong", success: 0 });
          }
        }.bind(this)
      );
    });
  }
  fetchOneClickCampaignVoucher(params) {
    const body_params = { ...params, sourceAdmin: 1 };
    return new Promise((resolve, reject) => {
      const getsites = {
        query: "storesAdmin.query.getOneClickSiteVouchers",
        tag: "storeAdmin",
        variables: {
          add_data: {
            ...body_params,
          },
        },
      };

      makeRequestAuth(
        getsites,
        function (response) {
          if (
            response &&
            response.data &&
            response.data.getOneClickSiteVouchers &&
            response.data.getOneClickSiteVouchers.success
          ) {
            resolve(response.data.getOneClickSiteVouchers);
          } else if (
            response &&
            response.data &&
            response.data.getOneClickSiteVouchers &&
            !response.data.getOneClickSiteVouchers.success
          ) {
            resolve(response.data.getOneClickSiteVouchers);
          } else {
            resolve({ Message: "Something went wrong", success: 0 });
          }
        }.bind(this)
      );
    });
  }
  createOneClickCampaign(params) {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.mutation.createOneClickCampaign";
      const request_data = {
        query: query,
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data && response.data.createOneClickCampaign) {
          resolve(response.data.createOneClickCampaign);
        } else {
          resolve({});
        }
      });
    });
  }
  editOneClickCampaign(params) {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.mutation.editOneClickCampaign";
      const request_data = {
        query: query,
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data && response.data.editOneClickCampaign) {
          resolve(response.data.editOneClickCampaign);
        } else {
          resolve({});
        }
      });
    });
  }
  updateOneClickCampaign(params) {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.mutation.updateOneClickCampaign";
      const request_data = {
        query: query,
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data && response.data.updateOneClickCampaign) {
          resolve(response.data.updateOneClickCampaign);
        } else {
          resolve({});
        }
      });
    });
  }
  generateLink(params) {
    return new Promise((resolve, reject) => {
      const getLink = {
        query: "storesAdmin.query.getGenerateLinks",
        tag: "storeAdmin",
        variables: {
          link_data: {
            campaignId: params.campaignId,
            linksCount: params.linksCount,
            method: params.method,
          },
        },
      };
      makeRequestAuth(getLink, (response) => {
        if (
          response &&
          response.data &&
          response.data.getGenerateLinks &&
          response.data.getGenerateLinks.success
        ) {
          resolve(response.data.getGenerateLinks);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  }

  fetchCampaignData = (params) => {
    return new Promise((resolve, reject) => {
      const getCamp = {
        query: "storesAdmin.query.getCampaignDetails",
        tag: "storeAdmin",
        variables: {
          camp_data: params,
        },
      };
      makeRequestAuth(getCamp, (response) => {
        if (response && response.data && response.data.getCampaignDetails) {
          resolve(response.data.getCampaignDetails);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  fetchLinkBasedRedemptionReport = (addData) => {
    return new Promise((resolve, reject) => {
      const getLinkBasedRedemptionReport = {
        query: "storesAdmin.query.linkBasedRedemptionReport",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(getLinkBasedRedemptionReport, (response) => {
        if (
          response &&
          response.data &&
          response.data.linkBasedRedemptionReport &&
          response.data.linkBasedRedemptionReport.success
        ) {
          resolve(response.data.linkBasedRedemptionReport);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  emailBatchDetails = (addData) => {
    return new Promise((resolve, reject) => {
      const batchDetails = {
        query: "storesAdmin.query.emailBatchDetails",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(batchDetails, (response) => {
        if (
          response &&
          response.data &&
          response.data.emailBatchDetails &&
          response.data.emailBatchDetails.success
        ) {
          resolve(response.data.emailBatchDetails);
        } else {
          resolve({
            Message: "Something went wrong",
            success: 0,
          });
        }
      });
    });
  };

  cancelBatchDetails = (addData) => {
    return new Promise((resolve, reject) => {
      const cancelBatch = {
        query: "storesAdmin.query.cancelBatchDetails",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(cancelBatch, (response) => {
        if (
          response &&
          response.data &&
          response.data.cancelBatchDetails &&
          response.data.cancelBatchDetails.success
        ) {
          resolve(response.data.cancelBatchDetails);
        } else {
          resolve({
            Message: "Something went wrong",
            success: 0,
          });
        }
      });
    });
  };

  createSendVouchers = (params, isCxml = false) => {
    return new Promise((resolve, reject) => {
      const createSendVouchers = {
        query: "storesAdmin.mutation.createSendVoucher",
        tag: "storeAdmin",
        variables: {
          create_send_input: params,
          isCxml: isCxml,
        },
      };
      makeRequestAuth(createSendVouchers, (response) => {
        if (response && response.data && response.data.createSendVoucher) {
          resolve(response.data.createSendVoucher);
        } else {
          resolve({});
        }
      });
    });
  };

  getSuperAdmins = () => {
    return new Promise((resolve, reject) => {
      const getSuperAdmins = {
        query: "storesAdmin.query.getSuperAdmins",
        tag: "storeAdmin",
        variables: {},
      };
      makeRequestAuth(getSuperAdmins, (response) => {
        if (response && response.data && response.data.getSuperAdmins) {
          resolve(response.data.getSuperAdmins);
        } else {
          resolve({});
        }
      });
    });
  };

  transferAdminFund = (params) => {
    return new Promise((resolve, reject) => {
      const transferWalletFund = {
        query: "storesAdmin.mutation.transferWalletFund",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(transferWalletFund, (response) => {
        if (response && response.data && response.data.transferWalletFund) {
          resolve(response.data.transferWalletFund);
        } else {
          resolve({});
        }
      });
    });
  };

  fetchSchedulerReport = (params) => {
    return new Promise((resolve, reject) => {
      const fetchSchedule = {
        query: "storesAdmin.query.fetchScheduleReport",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(fetchSchedule, (response) => {
        if (response && response.data && response.data.fetchScheduleReport) {
          resolve(response.data.fetchScheduleReport);
        } else {
          resolve({});
        }
      });
    });
  };

  addXoxoCodeScheduler = (params) => {
    return new Promise((resolve, reject) => {
      const addScheduleCode = {
        query: "storesAdmin.mutation.addXoxoCodeScheduler",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(addScheduleCode, (response) => {
        if (response && response.data && response.data.addXoxoCodeScheduler) {
          resolve(response.data.addXoxoCodeScheduler);
        } else {
          resolve({});
        }
      });
    });
  };

  cancelScheduler = (params) => {
    return new Promise((resolve, reject) => {
      const cancelSchedule = {
        query: "storesAdmin.mutation.cancelScheduler",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(cancelSchedule, (response) => {
        if (response && response.data && response.data.cancelScheduler) {
          resolve(response.data.cancelScheduler);
        } else {
          resolve({});
        }
      });
    });
  };

  GSTList = () => {
    return new Promise((resolve, reject) => {
      const query = "diy.query.client_gst_details_status";
      const request = {
        query: query,
        tag: "diy",
      };
      makeRequestAuth(request, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };
  getCurrency = (currency_params) => {
    return new Promise((resolve, reject) => {
      const query = "stores.query.getCurrency";
      const currencyRequest = {
        query,
        tag: "stores",
        variables: {
          currencyParams: currency_params,
        },
      };
      makeRequestAuth(currencyRequest, (response) => {
        if (
          response &&
          response.data &&
          response.data.getCurrencyDetails &&
          response.data.getCurrencyDetails.Error === false
        ) {
          resolve(response.data.getCurrencyDetails);
        } else {
          resolve({});
        }
      });
    });
  };

  fetchAlbumCategory = () => {
    return new Promise((resolve, reject) => {
      const currencyRequest = {
        query: "storesAdmin.query.template_fetch_category",
        tag: "storeAdmin",
      };
      makeRequestAuth(currencyRequest, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve({});
        }
      });
    });
  };

  getActivationSteps = () => {
    return new Promise((resolve, reject) => {
      const query = "diy.query.get_activation_steps";
      const request_data = {
        query,
        tag: "diy",
        variables: {},
      };
      makeRequestAuth(request_data, (response) => {
        if (response) {
          if (
            response &&
            response.data &&
            response.data.getActivationSteps &&
            response.data.getActivationSteps.success == 1
          ) {
            let kyb_status = response.data.getActivationSteps.data.kyb_status;
            let recharge_status =
              response.data.getActivationSteps.data.recharge_status;
            let reward_status =
              response.data.getActivationSteps.data.reward_status;
            let steps = response.data.getActivationSteps.data.steps;

            if (
              steps.length === 0 ||
              (recharge_status && kyb_status && reward_status)
            ) {
              resolve(false);
            } else {
              resolve(true);
            }
          } else {
            resolve(false);
          }
        } else {
          resolve(false);
        }
      });
    });
  };

  getSubscribedProPlan = (clientId) => {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.query.getSubscribedPlan";
      const options = {
        query,
        tag: "storeAdmin",
        variables: {
          client_data: clientId,
        },
      };
      makeRequestAuth(options, (response) => {
        if (response && response.data && response.data.getSubscribedPlan) {
          resolve(response.data.getSubscribedPlan);
        } else {
          resolve({});
        }
      });
    });
  };

  getClientWebhook = () => {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.query.getClientWebhook";
      const options = {
        query,
        tag: "storeAdmin",
        variables: {},
      };
      makeRequestAuth(options, (response) => {
        if (response && response.data && response.data.getClientWebhook) {
          resolve(response.data.getClientWebhook);
        } else {
          resolve({});
        }
      });
    });
  };

  addClientWebhook = (data) => {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.mutation.addClientWebhook";
      const options = {
        query,
        tag: "storeAdmin",
        variables: {
          add_data: data,
        },
      };
      makeRequestAuth(options, (response) => {
        if (response && response.data && response.data.addClientWebhook) {
          resolve(response.data.addClientWebhook);
        } else {
          resolve({});
        }
      });
    });
  };
  updateClientWebhook = (data) => {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.mutation.updateClientWebhook";
      const options = {
        query,
        tag: "storeAdmin",
        variables: {
          add_data: data,
        },
      };
      makeRequestAuth(options, (response) => {
        if (response && response.data && response.data.updateClientWebhook) {
          resolve(response.data.updateClientWebhook);
        } else {
          resolve({});
        }
      });
    });
  };

  subscribeProPlan = (data) => {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.mutation.subscribeProPlan";
      const options = {
        query,
        tag: "storeAdmin",
        variables: {
          add_data: data,
        },
      };
      makeRequestAuth(options, (response) => {
        if (response && response.data && response.data.subscribeProPlan) {
          resolve(response.data.subscribeProPlan);
        } else {
          resolve({});
        }
      });
    });
  };

  getAllSubscriptionPlans = () => {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.query.getAllSubscriptionPlans";
      const options = {
        query,
        tag: "storeAdmin",
      };
      makeRequestAuth(options, (response) => {
        if (
          response &&
          response.data &&
          response.data.getAllSubscriptionPlans
        ) {
          resolve(response.data.getAllSubscriptionPlans);
        } else {
          resolve({});
        }
      });
    });
  };

  resetCounterOfAdmin(payload) {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.mutation.resetAdminThreshold";
      const postData = {
        query: query,
        tag: "storeAdmin",
        variables: {
          add_data: payload,
        },
      };
      makeRequestAuth(postData, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve(0);
        }
      });
    });
  }

  getProductToClientBaseConversion(payload) {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.query.clientCurrencyConversion";
      const postData = {
        query: query,
        tag: "storeAdmin",
        variables: {
          conversion_data: payload,
        },
      };
      makeRequestAuth(postData, (response) => {
        if (
          response &&
          response.data &&
          response.data.clientCurrencyConversion
        ) {
          resolve(response.data.clientCurrencyConversion);
        } else {
          resolve({});
        }
      });
    });
  }

  clientCurrencyConversionToBase(payload) {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.query.clientCurrencyConversionToBase";
      const postData = {
        query: query,
        tag: "storeAdmin",
        variables: {
          conversion_data: payload,
        },
      };
      makeRequestAuth(postData, (response) => {
        if (
          response &&
          response.data &&
          response.data.clientCurrencyConversionToBase
        ) {
          resolve(response.data.clientCurrencyConversionToBase);
        } else {
          resolve({});
        }
      });
    });
  }

  getUserAssoc = async (payload) => {
    return new Promise((resolve, reject) => {
      const query = "stores.query.getUserAssoc";
      const postData = {
        query: query,
        tag: "stores",
        variables: { ...payload },
      };
      makeRequestAuth(
        postData,
        (response) => {
          if (response) {
            resolve(response);
          } else {
            resolve(0);
          }
        },
        {},
        "/api/public/graph"
      );
    });
  };
  getAutomationListByCampaignId = async (payload) => {
    return new Promise((resolve, reject) => {
      const query = "surveyMonkeyFroentend.query.survey_campanin_list";
      const postData = {
        query: query,
        tag: "surveyMonkeyFroentend",
        variables: {
          xoxo_campaign_id: payload,
          limit: 100,
          offset: 0,
          status: 1,
        },
      };
      makeRequestAuth(postData, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve(0);
        }
      });
    });
  };
  getDomainDetails = async (payload) => {
    return new Promise((resolve, reject) => {
      const query = "domain_auth.query.getDomainDetails";
      const postData = {
        query: query,
        tag: "domain_auth",
        variables: payload,
      };
      makeRequestAuth(postData, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve(0);
        }
      });
    });
  };
  addSenderDomain = async (payload) => {
    return new Promise((resolve, reject) => {
      const query = "domain_auth.mutation.addSenderDomain";
      const postData = {
        query: query,
        tag: "domain_auth",
        variables: {
          domain: payload,
        },
      };
      makeRequestAuth(postData, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve(0);
        }
      });
    });
  };
  triggerEmailSenderDomain = async (payload) => {
    return new Promise((resolve, reject) => {
      const query = "domain_auth.mutation.triggerEmailSenderDomain";
      const postData = {
        query: query,
        tag: "domain_auth",
        variables: {
          toEmail: payload.isEmailValid,
          message: payload.isSendBtnDisabled,
        },
      };
      makeRequestAuth(postData, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve(0);
        }
      });
    });
  };
  verifySenderDomain = async (payload) => {
    return new Promise((resolve, reject) => {
      const query = "domain_auth.mutation.verifySenderDomain";
      const postData = {
        query: query,
        tag: "domain_auth",
        variables: {},
      };
      makeRequestAuth(postData, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve(0);
        }
      });
    });
  };
}

export default new ProfileService();
